import { cn, Switch as NextUISwitch } from '@nextui-org/react'
import React from 'react'

export interface SwitchProps {
  /** Whether the switch is currently selected/checked */
  isSelected: boolean
  /** Callback function called when the switch state changes */
  onChange: (checked: boolean) => void
  /** Additional CSS class names to apply to the switch */
  className?: string
  /** Content to display as the switch label */
  children?: React.ReactNode
}

export function Switch({ isSelected, onChange, className, children }: SwitchProps) {
  return (
    <NextUISwitch
      isSelected={isSelected}
      onChange={ev => onChange(ev.target.checked)}
      className={className}
      classNames={{
        base: cn(
          'flex flex-row-reverse w-full items-center max-w-none',
          'justify-between cursor-pointer rounded-lg gap-2 select-none'
        ),
        wrapper: 'p-0 h-4 overflow-visible group-data-[selected=true]:bg-tokens-primary-2',
        thumb: cn(
          'w-6 h-6  shadow-lg',
          'group-data-[selected=true]:ms-6',
          'group-data-[pressed=true]:w-7',
          'group-data-[selected]:group-data-[pressed]:ms-4'
        ),
        label: 'text-base select-none'
      }}
    >
      {children}
    </NextUISwitch>
  )
}
